export enum RECURRENCE_TYPE {
  DAILY = 0,
  WEEKLY = 1,
  MONTHLY = 2,
  YEARLY = 3,
  DAYS_OF_WEEK = 4,
  CUSTOM = 5,
  DONT_REPEAT = 6,
}

export enum RECURRENCE_STATUS {
  ACTIVE = 0,
  PAUSED = 1,
  CANCELLED = 2,
}

export type RECURRENCE_CONFIG = {
  dailyInterval?: number;
  weeklyDays?: number[];
  weeklyInterval?: number;
  monthlyDay?: number;
  monthlyInterval?: number;
  yearlyMonth?: number;
  yearlyDay?: number;
  yearlyInterval?: number;
  timeOfDay?: string;
  timezone?: string;
};

export function getPtBrRecurrenceType(recurrenceType: RECURRENCE_TYPE): string {
  switch (recurrenceType) {
    case RECURRENCE_TYPE.DONT_REPEAT:
      return 'Não se repete';
    case RECURRENCE_TYPE.DAILY:
      return 'Diário';
    case RECURRENCE_TYPE.WEEKLY:
      return 'Semanal';
    case RECURRENCE_TYPE.MONTHLY:
      return 'Mensal';
    case RECURRENCE_TYPE.YEARLY:
      return 'Anual';
    case RECURRENCE_TYPE.DAYS_OF_WEEK:
      return 'Dias da semana';
    case RECURRENCE_TYPE.CUSTOM:
      return 'Personalizado';
    default:
      return '';
  }
}
